import React, { useState, useRef, useEffect } from 'react';
import styles from './FilePhoto.module.css';

const FilePhoto = ({ url, onUpload }) => {
  console.log(url)
  const [image, setImage] = useState("");
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.match('image.*')) {
      alert('Пожалуйста, выберите файл изображения');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setImage(e.target.result);
      prepareUploadData(file);
    };
    reader.readAsDataURL(file);
  };

  const prepareUploadData = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64Data = e.target.result.split(',')[1];
      const uploadData = {
        name: file.name.split('.')[0],
        extension: file.name.split('.').pop(),
        data: base64Data
      };
      if (onUpload) onUpload(uploadData);
    };
    reader.readAsDataURL(file);
  };

  const triggerFileInput = () => {
    fileInputRef.current.value = ''; // Сбрасываем значение, чтобы можно было выбрать тот же файл снова
    fileInputRef.current.click();
  };

  const handleRemove = () => {
    setImage(null);
    if (onUpload) onUpload(null);
  };

  useEffect(() => {
    if (url != "") {
      setImage(url);
    }
  }, [url])

  return (
    <div className={styles.container}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept="image/*"
        className={styles.fileInput}
      />

      {!image ? (
        <div className={styles.uploadArea} onClick={triggerFileInput}>
          <p>Нажмите для загрузки фото</p>
        </div>
      ) : (
        <div className={styles.imageWrapper}>
          <img src={image} alt="Загруженное изображение" className={styles.previewImage} />
          <div className={styles.controls}>
            <button onClick={triggerFileInput} className={styles.controlButton}>
              Изменить
            </button>
            <button onClick={handleRemove} className={styles.controlButton}>
              Удалить
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilePhoto;